import { api } from "./client";

export interface MinePlayerView {
  user_id: number;
  display_name: string;
  hero_class: string;
  phase: string;
}

export interface MineSlotView {
  slot_id: number;
  state: string;
  player_count: number;
  players: MinePlayerView[];
}

export interface MinePvpOffer {
  encounter_id: string;
  opponent_user_id: number;
  opponent_name: string;
  opponent_class: string;
  slot_id: number;
  accepted_by_you: boolean;
  accepted_by_opponent: boolean;
  status: string;
}

export interface MineDailyLimits {
  attempts_used: number;
  attempts_max: number;
  ore_earned_today: number;
  ore_cap_today: number;
  event_active: boolean;
  ore_per_run: number;
}

export interface MinePlayerState {
  is_in_mine: boolean;
  phase: string;
  current_slot_id: number | null;
  travel_seconds_left: number;
  mining_seconds_left: number;
  mining_progress_pct: number;
  pending_reward: number;
  current_ore: number;
  amethyst_balance: number;
  pvp: MinePvpOffer | null;
  can_select_slot: boolean;
  can_start_mining: boolean;
  can_claim: boolean;
  can_deliver: boolean;
  can_exit: boolean;
}

export interface MineStatus {
  unlocked: boolean;
  unlock_level: number;
  player: MinePlayerState;
  slots: MineSlotView[];
  daily: MineDailyLimits;
  message?: string | null;
  battle_id?: number | null;
}

export interface MineShopItem {
  code: string;
  name: string;
  amethyst_cost: number;
  gold_reward: number;
  description: string;
}

export interface MineShop {
  amethyst: number;
  items: MineShopItem[];
}

export const mineApi = {
  getStatus: () => api.get<MineStatus>("/mine/status"),
  enter: () => api.post<MineStatus>("/mine/enter"),
  selectSlot: (slotId: number) => api.post<MineStatus>("/mine/select-slot", { slot_id: slotId }),
  start: () => api.post<MineStatus>("/mine/start"),
  claim: () => api.post<MineStatus>("/mine/claim"),
  deliver: () => api.post<MineStatus>("/mine/deliver"),
  exit: () => api.post<MineStatus>("/mine/exit"),
  acceptPvp: (encounterId: string) => api.post<MineStatus>("/mine/pvp/accept", { encounter_id: encounterId }),
  getShop: () => api.get<MineShop>("/mine/shop"),
  buyShopItem: (itemCode: string, quantity = 1) =>
    api.post<{ ok: boolean; message: string; shop: MineShop; gold: number }>("/mine/shop/buy", {
      item_code: itemCode,
      quantity,
    }),
};
